import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { GlobalContants } from './constants/global.contants';
import { SharedService } from './services/shared.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'Estater Api';
  constructor(private sharedService: SharedService,
    private router: Router
  ){}
}
